/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A payload containing resourceIds to be added to a client entity
 * @export
 * @interface AssociateResourcesWithClient
 */
export interface AssociateResourcesWithClient {
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AssociateResourcesWithClient
	 */
	subjectRIDs: Array<string>;
	/**
	 * The permissions to be applied to the association.
	 * @type {Array<string>}
	 * @memberof AssociateResourcesWithClient
	 */
	permissions: Array<string>;
	/**
	 * The actorRIDs to be granted permissions on the subjectRIDs. These must be RIDs for users or groups.
	 * @type {Array<string>}
	 * @memberof AssociateResourcesWithClient
	 */
	actorRIDs?: Array<string>;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof AssociateResourcesWithClient
	 */
	presetRID: string;
}

/**
 * Check if a given object implements the AssociateResourcesWithClient interface.
 */
export function instanceOfAssociateResourcesWithClient(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'subjectRIDs' in value;
	isInstance = isInstance && 'permissions' in value;
	isInstance = isInstance && 'presetRID' in value;

	return isInstance;
}

export function AssociateResourcesWithClientFromJSON(
	json: any
): AssociateResourcesWithClient {
	return AssociateResourcesWithClientFromJSONTyped(json, false);
}

export function AssociateResourcesWithClientFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AssociateResourcesWithClient {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		subjectRIDs: json['subjectRIDs'],
		permissions: json['permissions'],
		actorRIDs: !exists(json, 'actorRIDs') ? undefined : json['actorRIDs'],
		presetRID: json['presetRID'],
	};
}

export function AssociateResourcesWithClientToJSON(
	value?: AssociateResourcesWithClient | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		subjectRIDs: value.subjectRIDs,
		permissions: value.permissions,
		actorRIDs: value.actorRIDs,
		presetRID: value.presetRID,
	};
}
